import ResultTable from "../../components/table/ResultTable";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../components/table/ResultBodyCell";
import HecRasHelper from "../../helpers/HecRasHelper";

export default function ShapeItem({feature}) {

    return (
        <>
            <ResultTable >
                {
                    Object.keys(feature?.properties).map(prop => {
                        return (
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(30), textAlign: 'start', verticalAlign: 'start', fontWeight: 'bold'}}>
                                    {prop}
                                </ResultHeaderCell>
                                <ResultBodyCell style={{width: HecRasHelper.getWidth(75)}}>
                                    <div dangerouslySetInnerHTML={{__html: feature?.properties[prop]}}/>
                                </ResultBodyCell>
                            </ResultRow>
                        )
                    })
                }
            </ResultTable>
        </>
    )
}

export function ShapeTooltip({labels, feature}) {
    return (
        <ResultTable >
            {
                labels?.map((prop, idx) => {
                    return (
                        <ResultRow>
                            <ResultHeaderCell style={{width: HecRasHelper.getWidth(30), textAlign: 'start', verticalAlign: 'start', fontWeight: 'bold'}}>{prop}</ResultHeaderCell>
                            <ResultBodyCell style={{width: HecRasHelper.getWidth(75)}}>
                                <div dangerouslySetInnerHTML={{__html: feature?.properties[prop]}}/>
                            </ResultBodyCell>
                        </ResultRow>
                    )
                })
            }
        </ResultTable>
    )
}